// extracted by mini-css-extract-plugin
module.exports = {"buscador":"SearchBar_buscador__18NBm","form":"SearchBar_form__qBdjT","barra":"SearchBar_barra__2aL7D","boton":"SearchBar_boton__1-uUU","navLink":"SearchBar_navLink__1kQ3_"};